import LogoSvg from './logo.svg'

export const LogoImg = (props) => <img src={LogoSvg} {...props} alt={LogoSvg}/>